module.exports = __webpack_public_path__ + "static/media/0115_Small.5d2d5f29.jpg";